import React from 'react'

export const PeopleList = ({
  people,
  peopleHeadline,
  peopleText,
  peopleLayout,
}) => {
  // Decide which CSS rules and content to apply to list of people using peopleLayout
  switch (peopleLayout) {
    // Currently being used for Board Members
    case 'Name and Text':
      return (
        <div className="mb-24">
          <h2 className="mt-16 font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
            {peopleHeadline}
          </h2>
          <div className="pt-10 mt-6 border-t-2 border-gray-400">
            <div dangerouslySetInnerHTML={{ __html: peopleText }}></div>
            <div className="flex flex-wrap">
              {people.map(person => (
                <div
                  className="mt-3 md:w-1/2 md:mt-3 md:px-3"
                  key={person.personName}
                >
                  <h3 className="text-2xl text-left lg:text-3xl">
                    {person.personName}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{ __html: person.personText }}
                    className="text-sm leading-normal prose text-gray-500"
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    // Currently being used for interns and writing staff
    case 'Name and Title':
      return (
        <div className="mb-24 text-center">
          <h2 className="mt-16 font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
            {peopleHeadline}
          </h2>
          <div className="pt-10 mt-6 border-t-2 border-gray-400">
            <div dangerouslySetInnerHTML={{ __html: peopleText }}></div>
            <div className="flex flex-wrap lg:-mx-5 xl:-mx-8">
              {people.map(person => (
                <div
                  className="w-full max-w-xs mx-auto lg:w-1/3 lg:px-5 xl:px-8"
                  key={person.personName}
                >
                  <div className="mt-5">
                    <h3 className="text-xl leading-tight lg:text-2xl">
                      {person.personName}
                    </h3>
                    <h4 className="mt-1 text-xs font-semibold leading-snug uppercase">
                      {person.personTitle}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    // Default is being used for the "supporters" since it will be most common
    default:
      return (
        <div className="mb-24">
          <h2 className="mt-16 font-sans text-4xl font-bold leading-tight tracking-wider text-center uppercase text-brand-red sm:text-5xl">
            {peopleHeadline}
          </h2>
          <div dangerouslySetInnerHTML={{ __html: peopleText }}></div>
          <div className="pt-10 mt-6 border-t-2 border-gray-400">
            <div className="text-lg leading-normal text-center text-gray-500 ">
              <div className="flex flex-col flex-wrap lg:flex-row xl:-mx-4">
                {people.map(person =>
                  person.personFoundingFunder ? (
                    <span
                      className="w-full italic lg:w-1/2 xl:px-4"
                      key={person.personName}
                    >
                      {person.personName}
                    </span>
                  ) : (
                    <span
                      className="w-full lg:w-1/2 xl:px-4"
                      key={person.personName}
                    >
                      {person.personName}
                    </span>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      )
  }
}
